import { render, staticRenderFns } from "./SettingFormEdit.vue?vue&type=template&id=4ff60cdc&scoped=true&"
import script from "./SettingFormEdit.vue?vue&type=script&lang=js&"
export * from "./SettingFormEdit.vue?vue&type=script&lang=js&"
import style0 from "./SettingFormEdit.vue?vue&type=style&index=0&id=4ff60cdc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff60cdc",
  null
  
)

export default component.exports